import HeaderSearchAppData from '@/header/models/header-search-app-data.model';

export default window.headerSearchAppData as HeaderSearchAppData;